import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './OffersCleanerPage.module.scss';
import CustomerBioShort from "../../components/CustomerBioShort/CustomerBioShort";
import {offerActions} from "../../store/slices/offerSlice";
import EmptyState from "../EmptyState/EmptyState";
import waiting from '../../constants/images/detailsOrder/waiting.svg';
import Loader from "../../components/Loader/Loader";
import isCleaner from "../../HOC/IsCleaner";

const OffersCleanerPage = () => {
    const dispatch = useDispatch();
    const {offersByCurrentUser, status} = useSelector(state => state.offer);

    useEffect(() => {
        const getAllOffersByCurrentUser = async () => {
            try {
                await dispatch(offerActions.getAllOffersByCurrentUser());
            } catch (error) {
                console.error(error);
            }
        }

        getAllOffersByCurrentUser();
    }, []);

    if (status === 'loading') {
        return <Loader/>;
    }

    return (
        <div className={styles.offersCleanerPage_wrapper}>
            <div className={styles.offersCleanerPage}>
                <div className={styles.offersCleanerPage_offers}>
                    <h2 className={styles.offersCleanerPage_offers_title}>Пропозиції</h2>
                    <div className={styles.offersCleanerPage_offers_content}>
                        {offersByCurrentUser?.length === 0 &&
                            <EmptyState
                                icon={waiting}
                                title={'У вас поки немає пропозицій від замовників.'}
                                description={'Будь ласка, зачекайте, поки замовники розглянуть вашу заявку. Сторінка оновиться автоматично, коли будуть доступні пропозиції.'}
                            />}
                        {offersByCurrentUser.map((offer, index) =>
                            <CustomerBioShort
                                key={index}
                                type={'offer'}
                                order={offer.cleaner_request}
                                offerId={offer.id}
                                orderId={null}
                                application={offer.application}
                            />)}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default isCleaner(OffersCleanerPage);
